export default "__VITE_ASSET__DRn3N9x0__"